import { useState, SetStateAction, Dispatch, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Buscar } from "../Buscar/Buscar";
import { UnidadList } from "../UnidadList/UnidadList";
import { useGetPaginatedData } from "../../../hooks/useGetPaginatedData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { UnidadInterface } from "../../../interfaces/UnidadInterface";
import { UnidadCrearModal } from "../UnidadCrearModal/UnidadCrearModal";
import { SimplePagination } from "../../Common/SimplePagination/SimplePagination";
import {
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";

//Estilos
const classes = require("./Unidades.module.css").default;

interface Props {
  setValue: UseFormSetValue<any>;
  actividad: any[];
  getValues: UseFormGetValues<any>;
  setActividad: Dispatch<SetStateAction<any[]>>;
}

export const Unidades = ({
  setValue,
  getValues,
  setActividad,
  actividad,
}: Props) => {
  const [term, setTerm] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);

  // Hook paginado con búsqueda del servidor
  const { 
    data: unidadesList, 
    pagination, 
    isLoading 
  } = useGetPaginatedData<UnidadInterface>(
    `/unidad?includeAll[eq]=true`,
    `unidadesSucursal`,
    currentPage,
    20,
    term // Pasar término de búsqueda al servidor
  );

  // Resetear a página 1 cuando cambia el término de búsqueda
  useEffect(() => {
    if (term) {
      setCurrentPage(1);
    }
  }, [term]);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <>
      <Row>
        <h2 className={classes.subtitulo}>Datos de instalación y unidades</h2>
        <Col xs={4}>
          <Buscar onDebounce={(value) => setTerm(value)} />
        </Col>
        <Col xs={2} style={{ padding: "10px" }}>
          <Button
            title="Crear unidad"
            style={{
              backgroundColor: "#5DADE2",
              borderColor: "white",
            }}
            onClick={handleShowModal}
          >
            <FontAwesomeIcon icon={faAdd as IconProp} />
          </Button>
        </Col>
      </Row>
      
      <Row className="mt-3">
        <UnidadList
          unidadesList={unidadesList}
          setValue={setValue}
          getValues={getValues}
          setActividad={setActividad}
          actividad={actividad}
          isLoading={isLoading}
        />
      </Row>

      {!isLoading && (
        <SimplePagination
          currentPage={pagination.currentPage}
          lastPage={pagination.lastPage}
          total={pagination.total}
          perPage={pagination.perPage}
          onPageChange={setCurrentPage}
        />
      )}

      {showModal && (
        <UnidadCrearModal
          showModal={showModal}
          handleCloseModal={handleCloseModal}
        />
      )}
    </>
  );
};
